import { useFormContext } from 'react-hook-form';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@radix-ui/react-label';
import { FormControl, FormField, FormItem } from './ui/form';

interface CheckboxGroupOption {
  label: string;
  value: string;
}

interface FormFieldCheckboxGroupProps {
  name: string;
  options: CheckboxGroupOption[];
  label?: string;
  required?: boolean;
}

export const FormFieldCheckBoxGroup: React.FC<FormFieldCheckboxGroupProps> = ({ name, options, label, required }) => {
  const { control } = useFormContext();
  return (
    <FormField
      control={control}
      name={name}
      render={({ fieldState, field }) => {
        const selected = (field.value as string[]) ?? [];

        const handleToggle = (value: string) => {
          let newValue: string[];
          if (selected.includes(value)) {
            newValue = selected.filter((v: string) => v !== value);
          } else {
            newValue = [...selected, value];
          }
          field.onChange(newValue);
        };
        return (
          <>
            <FormItem className="text-sm">
              {label && (
                <Label className="font-medium">
                  {label} {required && <span className="text-error align-top">*</span>}
                </Label>
              )}
              <FormControl>
                <div className="flex flex-row gap-6 pt-2">
                  {options.map((opt, index) => (
                    <label key={opt.value} className="flex items-center space-x-2 cursor-pointer">
                      <Checkbox
                        checked={selected.includes(opt.value)}
                        onCheckedChange={() => handleToggle(opt.value)}
                        onBlur={index === options.length - 1 ? field.onBlur : undefined}
                      />
                      <span className="font-medium">{opt.label}</span>
                    </label>
                  ))}
                </div>
              </FormControl>
            </FormItem>
            {fieldState.error && <p className="text-error text-xs mt-3">{fieldState.error.message}</p>}
          </>
        );
      }}
    />
  );
};
